import React from "react"
import { Navigate, Route, Routes as SwitchRoutes, useLocation } from "react-router-dom"
import Bookmanagement from "./Bookmanagement"
import Lizenzen from "./Lizenzen"
import { F_VERWALTUNG_BOOKS, F_VERWALTUNG_BOOKS_SHORT, F_VERWALTUNG_LICENCES_SHORT } from "../../constants/routes"
import RootContainer from "../Trading/RootContainer"
import { useMediaQuery, useTheme } from "@mui/material"
import TooSmallInfo from "./TooSmallInfo"

const Schuladmin = () => {
  const location = useLocation()

  const theme = useTheme()
  const isTooSmall = useMediaQuery(theme.breakpoints.down("sm"))

  const DefaultPage = isTooSmall ? TooSmallInfo : Bookmanagement

  return (
    <RootContainer bookmanagement>
      <SwitchRoutes location={location}>
        <Route path="/" element={<Navigate to={F_VERWALTUNG_BOOKS} replace />} />

        <Route path={F_VERWALTUNG_BOOKS_SHORT} element={<DefaultPage />} />
        <Route path={F_VERWALTUNG_LICENCES_SHORT} element={<Lizenzen />} />

        <Route path="*" element={<DefaultPage />} />
      </SwitchRoutes>
    </RootContainer>
  )
}

export default Schuladmin
